import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

// Таны хуудсууд
import HomePage from "./pages/home";
import ExamTest from "./pages/exam-test";
import SingleTest from "./pages/single-test";
import TopicTest from "./pages/topic-test";
import AdditionalTest from "./pages/additional-test";
import AdditionalSingleTest from "./pages/additional-single-test";
import AdditionalExamTest from "./pages/additional-exam-test";
import NotFoundPage from "./pages/404";
import Login from "./pages/login";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={Login} />

          {/* Хамгаалалттай замууд */}
          <ProtectedRoute exact path="/" component={HomePage} />
          <ProtectedRoute path="/exam-test" component={ExamTest} />
          <ProtectedRoute
            path="/additional-exam-test"
            component={AdditionalExamTest}
          />
          <ProtectedRoute path="/topic-test/:topicId" component={SingleTest} />
          <ProtectedRoute path="/topic-test" component={TopicTest} />
          <ProtectedRoute
            path="/additional-test/:topicId"
            component={AdditionalSingleTest}
          />
          <ProtectedRoute path="/additional-test" component={AdditionalTest} />

          {/* 404 хуудас - хамгийн сүүлд */}
          <Route component={NotFoundPage} />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
